import { useEffect, useState, useContext } from "react";
import { get } from "lodash";
import { withRouter } from "react-router-dom";
import { BsBookmark, BsBookmarkFill } from "react-icons/bs";
import { calcCoordsDist, getid, joinStrs } from "../../utils/functions";
import axios from "../../axios";
import { Col, Flex, Row } from "../Common.Styled";
import * as SC from "./Styled";
import { toast } from "react-toastify";
import Spinner from "../Spinner";
import { connect } from "react-redux";
import * as actionTypes from "../../store/actions";
import { LanguageContext } from "../../utils/language/Language";

const topInputsText = {
  "Total Bedrooms": (v) => v + " Bds",
  "Total Full Bath": (v) => v + " Bth",
  "Building Area": (v) => v + " sq ft",
  "Year Built": (v) => " " + v,
};

const PropertiesListing = ({
  setUsers,
  history,
  isLoading,
  properties,
  onSave,
  onUnsave,
  onSaveUnsave,
  mainContClassName,
  parentStatus,
  shareBtn,
  loadShareData,
  homeList,
  fromManage
  
}) => {
  const [currentPos, setCurrentPos] = useState(null);
  const [isSaving, setIsSaving] = useState(false);

  const [isCheckAll, setIsCheckAll] = useState(false);
  const [isCheck, setIsCheck] = useState([]);
  const [list, setList] = useState([]);

  // useEffect(() => {
  //   setList(Catalogues);
  // }, [list]);

  //localization
  const defaultLanguage = window.localStorage.getItem("rcml-lang") || "en";
  const { dictionary } = useContext(LanguageContext);

  useEffect(() => {
    navigator.geolocation.getCurrentPosition((currentPos) => {
      setCurrentPos({
        lat: currentPos.coords.latitude,
        lng: currentPos.coords.longitude,
      });
    });
  }, []);

  const saveProperty = async ({ id }) => {
    setIsSaving(true);

    try {
      const {data} = await axios.post("/mark-as-save", { property_id: id });
      // toast.success(`${data.message}`);
      onSave && onSave({ id });
      onSaveUnsave && onSaveUnsave({ id, saved: true });
    } catch (err) {
      console.log(err);
      toast.error(`${err.response.data.message}`);
    }

    setIsSaving(false);
  };

  const unsaveProperty = async ({ id }) => {
    setIsSaving(true);

    try {
      const {data} = await axios.post("/unsave-property", { property_id: id });
      // toast.success(`${data.message}`);
      onUnsave && onUnsave({ id });
      onSaveUnsave && onSaveUnsave({ id, saved: false });
    } catch (err) {
      console.log(err);
      toast.error(`${err.response.data.message}`);
    }

    setIsSaving(false);
  };

  const propertyStatus = {
    1: dictionary.menzilString.Active,
    2: dictionary.menzilString.Withdrawl,
    3: dictionary.menzilString.Expired,
    4: dictionary.menzilString.Pending,
    5: dictionary.menzilString.Sold,
  };

  const handleSelectAll = (e) => {
    setIsCheckAll(!isCheckAll);
    setIsCheck(list.map((li) => li.id));
    if (isCheckAll) {
      setIsCheck([]);
    }
  };

  const handleClick = (e) => {
    const { id, checked } = e.target;
    setIsCheck([...isCheck, id]);
    loadShareData([...isCheck, id]);
    if (!checked) {
      setIsCheck(isCheck.filter((item) => item !== id));
    }
  };

  console.log("homeList", homeList);

  return (
    <SC.MainCont className={joinStrs(mainContClassName)}>
      {isLoading ? (
        <Spinner color wrpStyles />
      ) : (
        <SC.PropertyBox>
          {(homeList ? properties?.slice(0, 3) : properties)?.map((property) => (
            <SC.Card
              onClick={() =>
                history.push({
                  pathname: "/property/" + getid(property),
                  state: {...parentStatus,
                    fromManage : true
                  },
                })
              }
            >
              <SC.CardImgWrp>
                <img src={get(property, "images[0]", "")} alt={get(property, "property_name", "")} />
                <SC.CardSaveBtn
                  className={joinStrs(property.save_property && "property-saved")}
                  disabled={isSaving}
                  onClick={(e) => {
                    e.stopPropagation();

                    if (!property.save_property) {
                      saveProperty({ id: getid(property) });
                    } else {
                      unsaveProperty({ id: getid(property) });
                    }
                  }}
                >
                  {property.save_property ? <BsBookmarkFill /> : <BsBookmark />}
                </SC.CardSaveBtn>
                {shareBtn && (
                  <SC.CardShareBtn
                    onClick={(e) => {
                      e.stopPropagation();
                    }}
                  >
                    <input type="checkbox" id={getid(property)} onChange={handleClick} />
                  </SC.CardShareBtn>
                )}
                {currentPos && (
                  <SC.DistLabel>
                    {calcCoordsDist(
                      currentPos,
                      { lat: property.latitude, lng: property.longitude },
                      'mile'
                    )}{" "}
                    {dictionary.menzilString.away}
                  </SC.DistLabel>
                )}
              </SC.CardImgWrp>

              <SC.CardTxtWrp>
                <Flex jc="sb" ai="c">
                  <SC.PropStatus className="prop-status-active" IsColoured={property?.current_property_status?.property_status}>
                    {propertyStatus[property?.current_property_status?.property_status]}
                  </SC.PropStatus>
                  <SC.PropTopDets>
                    {get(property, "top_inputs.other", [])
                      .map((inp) => topInputsText[inp.input_name] && topInputsText[inp.input_name](inp.value))
                      .filter(Boolean)
                      .join(" | ")}
                  </SC.PropTopDets>
                </Flex>

                <Flex jc="sb">
                  <SC.PropName>{get(property, "property_name", "")}</SC.PropName>
                  <SC.PropPrice>{get(property, "top_inputs.price.input_prefix_value", "")} {parseFloat(get(property, "top_inputs.price.value", "0")).toFixed(2)} </SC.PropPrice>
                </Flex>
              </SC.CardTxtWrp>
            </SC.Card>
          ))}
        </SC.PropertyBox>
      )}
    </SC.MainCont>
  );
};

const mapStateToProps = (state) => {
  return {
    userData: state.userData,
    locationData: state.locations,
    defaultState: state.defaultState,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setUsers: (updatedValue) => {
      dispatch({
        type: actionTypes.UPDATE_USER,
        updatedUser: updatedValue,
      });
    },
    setDefaultState: (updatedValue) => {
      dispatch({
        type: actionTypes.UPDATE_DEFAULT,
        updateDefault: updatedValue,
      });
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(PropertiesListing));
